import type { WwmEventRoleKey } from "@/core/guild-events/types"

import { getRoleLabel } from "@/core/guild-events/labels"
import { cn } from "@/lib/utils"

// NOTE: minimal cross-layer contract — repo's GuildEventSignupWithDisplay has Date
// fields, api-client's GuildEventSignupRecord has string; this subset is type-compatible
// with both, decoupling the shared component from either layer.
export type RosterSignupEntry = {
  id: string
  memberId: string
  roleKey: WwmEventRoleKey | null
  guildDisplayName: string
}

type Props = {
  signups: RosterSignupEntry[]
  variant: "member" | "admin"
  viewerMemberId?: string
}

export function RosterColumns({ signups, variant, viewerMemberId }: Props) {
  if (signups.length === 0) {
    return <p className="text-sm text-muted-foreground">No members.</p>
  }

  return (
    <ul className="divide-y divide-border md:max-h-72 md:overflow-y-auto">
      {signups.map((signup) => {
        const isViewer =
          variant === "member" && signup.memberId === viewerMemberId
        const role = signup.roleKey ? getRoleLabel(signup.roleKey) : null
        return (
          <li
            key={signup.id}
            className={cn(
              "px-1 py-1.5 text-sm",
              isViewer &&
                "rounded-md bg-muted font-semibold ring-1 ring-primary/30",
            )}
          >
            <div>
              {signup.guildDisplayName}
              {isViewer ? " (you)" : null}
              {role ? (
                <span className="text-muted-foreground"> · {role}</span>
              ) : null}
            </div>
          </li>
        )
      })}
    </ul>
  )
}
